import { Component, OnInit } from '@angular/core';
import { TeamService } from 'src/app/services/team/team.service';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

  constructor(public ts:TeamService) { }

  ngOnInit(): void {
  }

}
